
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { BannerHalfBlurred } from 'components/common/BannerHalfBlurred';
import { Meta } from 'components/common/Meta';
import { BannerContent } from 'components/how-it-works/BannerContent';
import routes from 'constants/routes';
import { useIsMounted } from 'hooks/useIsMounted';
import type { Router } from 'instantsearch.js';
import { BaseLayout } from 'layouts/BaseLayout';
import { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import singletonRouter from 'next/router';
import { ReactElement, Suspense, lazy, useState } from 'react';
import { createInstantSearchRouterNext } from 'react-instantsearch-router-nextjs';
const Filters = lazy(() => import('components/artists/Filters').then(m => ({ default: m.Filters })));
const FiltersMobile = lazy(() => import('components/artists/Filters').then(m => ({ default: m.FiltersMobile })));
const List = lazy(() => import('components/artists/List').then(m => ({ default: m.List })));
const InstantSearch = lazy(() => import('components/common/InstantSearch').then(m => ({
    default: m.InstantSearch
})));
const Configure = dynamic(() => import('react-instantsearch').then(m => m.Configure), { ssr: false });
const instantSearchRouter = createInstantSearchRouterNext({
    singletonRouter
});
const Artists = () => {
    const { t } = useTranslation();
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const isMounted = useIsMounted();
    return (<>
      <Meta pageTitle={t('artists:page_title')} pageDescription={t('artists:page_desc')} imageName='social-artists-page' relativeUrl={routes.artists}/>

      <div className='min-h-screen w-full'>
        <BannerHalfBlurred src='/images/banners/artists.png' priority loading='eager' reversed sizes='100vw'>
          <BannerContent title='Artists' description='1/4 of our fees go back to the artist. No more excuses.'/>
        </BannerHalfBlurred>

        {isMounted && (<InstantSearch index='filter' routing={{
                router: instantSearchRouter as Router<unknown>
            }}>
            <Configure hitsPerPage={30} page={0}/>

            <div style={showMobileFilters
                ? { opacity: 1, pointerEvents: 'all' }
                : { opacity: 0, pointerEvents: 'none' }} className='fixed left-0 top-0 z-50 h-screen w-full transition-opacity duration-[350ms] ease-in-out'>
              <Suspense>
                <FiltersMobile setShowMobileFilters={setShowMobileFilters}/>
              </Suspense>
            </div>

            <div className='mb-16 min-h-[calc(100vh_-_theme(spacing.16))] w-full md:mb-20 lg:min-h-[calc(100vh_-_theme(spacing.20))]'>
              <Suspense>
                <Filters setShowMobileFilters={setShowMobileFilters}/>
              </Suspense>

              <Suspense>
                <List />
              </Suspense>
            </div>
          </InstantSearch>)}
      </div>
    </>);
};
Artists.getLayout = (page: ReactElement) => (<BaseLayout style='off-white-bg'>{page}</BaseLayout>);
const getStaticProps: GetStaticProps = async () => ({ props: {} });
export default Artists;

    async function __Next_Translate__getStaticProps__1951e780482__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/artists/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1951e780482__ as getStaticProps }
  